'use client';

import { ArrowDropDown } from '@mui/icons-material';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import SaveAsIcon from '@mui/icons-material/SaveAs';
import { Button, ListItemIcon, ListItemText, Menu, MenuItem } from '@mui/material';
import { useState } from 'react';

export function ProjectOpenButton(props: {
  /**
   * 내작품에서 선택 버튼 클릭
   */
  onClickOpenFromServerBtn: React.MouseEventHandler;

  /**
   * 파일 불러오기 선택
   */
  onClickOpenFromFileSelect: React.MouseEventHandler;
}) {
  const { onClickOpenFromServerBtn, onClickOpenFromFileSelect } = props;
  const [menuAnchorEl, setMenuAnchorEl] = useState<null | HTMLElement>(null);
  const menuOpened = Boolean(menuAnchorEl);

  const handleClose = () => {
    setMenuAnchorEl(null);
  };

  return (
    <>
      <Button
        className="ProjectOpenButton-root"
        color="inherit"
        onClick={(e) => {
          setMenuAnchorEl(e.target as HTMLElement);
        }}
        endIcon={<ArrowDropDown />}
      >
        불러오기
      </Button>
      <Menu anchorEl={menuAnchorEl} open={menuOpened} onClose={handleClose}>
        <MenuItem
          onClick={(e) => {
            handleClose();
            setTimeout(() => {
              onClickOpenFromServerBtn(e);
            }, 50);
          }}
        >
          <ListItemIcon>
            <SaveAsIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>내 프로젝트 선택</ListItemText>
        </MenuItem>
        <MenuItem
          onClick={(e) => {
            handleClose();
            setTimeout(() => {
              onClickOpenFromFileSelect(e);
            }, 50);
          }}
        >
          <ListItemIcon>
            <FileDownloadIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>파일 불러오기</ListItemText>
        </MenuItem>
      </Menu>
    </>
  );
}
